module.exports = __webpack_public_path__ + "static/media/bulto.7a9ca859.png";